import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'feeType',
    'prefix',
    'emptyLabel',
    'tariffWrapper',
    'tariffInput',
    'fixedWrapper',
    'fixedInput',
  ];

  static classes = ['hidden', 'muted'];

  connect() {
    // Initialise the correct input when the controller loads.
    this.update();
  }

  update() {
    const selectedFeeType = this.feeTypeTarget.value;
    const selectedOption = this.feeTypeTarget.selectedOptions[0];

    const hasFeeType = selectedFeeType !== '';
    const isTariffFee = selectedFeeType === 'tariff_fee';

    // Show only the input associated with the selected fee type.
    this.toggle(this.emptyLabelTarget, !hasFeeType);
    this.toggle(this.tariffWrapperTarget, hasFeeType && isTariffFee);
    this.toggle(this.fixedWrapperTarget, hasFeeType && !isTariffFee);

    // Disabled inputs are excluded from the submitted form data.
    this.setDisabled(this.tariffInputTarget, !hasFeeType || !isTariffFee);
    this.setDisabled(this.fixedInputTarget, !hasFeeType || isTariffFee);

    // Read the displayed prefix from the selected option's data attributes.
    this.prefixTarget.textContent = selectedOption?.dataset.prefix || '';

    // Apply the selected fixed-fee validation settings to the number input.
    if (selectedOption && !isTariffFee) {
      this.fixedInputTarget.step = selectedOption.dataset.step || '1';
      this.fixedInputTarget.min = selectedOption.dataset.min || '100';
      this.fixedInputTarget.max = selectedOption.dataset.max || '';
      this.fixedInputTarget.placeholder =
        selectedOption.dataset.placeholder || '';
    }
  }

  toggle(element, shouldShow) {
    element.classList.toggle(this.hiddenClass, !shouldShow);
  }

  setDisabled(element, disabled) {
    element.disabled = disabled;
  }
}
